import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import VehicleCardSkeleton from './VehicleCardSkeleton';

const SkeletonResultContainer = styled.div`
  margin: 0 ${(props) => props.theme.size.grid002};
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0040};
`;

const TopBarSkeleton = styled.div`
  margin-bottom: ${(props) => props.theme.size.dynamic0100};
  height: 34px;
`;

const ResultsSkeleton = () => {
  return (
    <SkeletonResultContainer>
      <TopBarSkeleton>
        <Skeleton height={46} />
      </TopBarSkeleton>

      <VehicleCardSkeleton />
      <VehicleCardSkeleton />
      <VehicleCardSkeleton />
    </SkeletonResultContainer>
  );
};

export default ResultsSkeleton;
